import React, { useState } from "react";
import TitlePage from "Components/TitlePage";
import useStyles from "./styles";
import { Button } from "Components/Form";
import { Color } from "Components/Form/Button";
import { Box, MenuItem } from "@mui/material";
import { Grid } from "@mui/material";
import Chip from "Components/Form/Chip";
import { FormFeedbackCard } from "Components/Form/FeedbackCard";
import FieldView from "Components/Form/FieldView";
import FilterMenu from "Components/Form/FilterMenu";
import { FormError } from "Components/Form/FormError";
import LabelForm from "Components/Form/Label";
import { SplitButton } from "Components/Form/SplitButton";
import Switch from "Components/Form/Switch";
import TableOutlineFilterButton from "Components/Form/TableOutlineFilterButton/TableOutlineFilterButton";
import { ToolTipInfo, TooltipPlacements } from "Components/Form/ToolTipInfo";
import CheckboxSection from "./components/checkbox";
import AutoSuggestSection from "./components/autoSuggest";
import InputSection from "./components/input";
import SelectSection from "./components/select";
import VoyagesSection from "./components/voyage";
import DispatchSection from "./components/dispatch";

function Component() {
  const [loading, setLoading] = useState<boolean>(false);
  const [isDateRange, setSelectDateRange] = useState<boolean>(true);
  const [showFeedbackCard, setShowFeedbackCard] = useState<boolean>(false);
  const [chips, setChips] = useState<string[]>(["Chip 1", "Chip 2", "Chip 3"]);
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [filterCount, setFilterCount] = useState<number>(3);

  const classes = useStyles();

  const handleButton = () => {
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  const handleDelete = (chipToDelete: string) => {
    setChips((prev) => prev.filter((chip) => chip !== chipToDelete));
  };

  const handleFeedbackCard = () => {
    setLoading(true);
    setTimeout(() => {
      setShowFeedbackCard(!showFeedbackCard);
      setLoading(false);
    }, 1000);
  };

  return (
    <div>
      {/* <TitlePage title="Example components" /> */}
      <div className={classes.mainDiv}>
        <AutoSuggestSection />
        <div>
          <div className={classes.buttonLabel}>
            <LabelForm className={classes.formLabel}>Button</LabelForm>
          </div>
          <div className={classes.buttonGroup}>
            <Button
              customColor={Color.SECONDARY}
              size="small"
              onClick={handleButton}
              loading={loading}
              variant="outlined"
            >
              outlined
            </Button>

            <Button
              customColor={Color.SECONDARY}
              size="medium"
              onClick={handleButton}
              loading={loading}
              variant="contained"
            >
              contained
            </Button>

            <Button
              customColor={Color.SECONDARY}
              size="large"
              onClick={handleButton}
              loading={loading}
              variant="text"
            >
              text
            </Button>
          </div>
          <hr />
        </div>
        <CheckboxSection />
        <InputSection />
        <SelectSection />
        <div>
          <div>
            <LabelForm className={classes.formLabel}>Chip</LabelForm>
          </div>
          <Box className={classes.chipContainer}>
            {chips.map((label) => (
              <Chip
                key={label}
                label={`${label} outlined`}
                onDelete={() => handleDelete(label)}
                color="primary"
                variant="outlined"
              />
            ))}
            <Chip label="disabled" disabled variant="outlined" />
          </Box>
          <Box className={classes.chipContainer}>
            {chips.map((label) => (
              <Chip
                key={label}
                label={`${label} default`}
                onDelete={() => handleDelete(label)}
                color="primary"
              />
            ))}
            <Chip label="disabled" disabled />
          </Box>
          <hr />
        </div>
        <div>
          <div>
            <LabelForm className={classes.formLabel}>FormFeedbackCard</LabelForm>
          </div>
          <FormFeedbackCard text={"FormFeedbackCardExample"} hide={showFeedbackCard} />
          <Button
            customColor={Color.SECONDARY}
            size="small"
            onClick={() => handleFeedbackCard()}
            loading={loading}
            variant="outlined"
            className={classes.buttonFeedbackCard}
          >
            Click me
          </Button>
          <hr />
        </div>
        <div>
          <div>
            <LabelForm className={classes.formLabel}>FieldView</LabelForm>
          </div>
          <Grid container direction="row" spacing={3} className={classes.gridContainer}>
            <Grid item md={4} sm={6} xs={12} className={classes.gridItem}>
              <FieldView label="FieldView1" value="fieldView1" />
            </Grid>

            <Grid item md={4} sm={6} xs={12} className={classes.gridItem}>
              <FieldView label="FieldView2" value="fieldView2" />
            </Grid>

            <Grid item md={4} sm={12} xs={12} className={classes.gridItem}>
              <FieldView label="FieldView3" value="fieldView3" />
            </Grid>

            <Grid item md={6} sm={12} xs={12} className={classes.gridItem}>
              <FieldView label="FieldView4" value="fieldView4" />
            </Grid>
          </Grid>
          <hr />
        </div>
        <div>
          <div>
            <LabelForm className={classes.formLabel}>FilterMenu</LabelForm>
          </div>
          <FilterMenu isDateRange={isDateRange} setIsDateRange={setSelectDateRange} />
          <br />
          <FilterMenu isDateRange={isDateRange} setIsDateRange={setSelectDateRange} disabled />
          <hr />
        </div>
        <div>
          <div>
            <LabelForm className={classes.formLabel}>FormError</LabelForm>
          </div>
          <FormError isError={true}>FormError</FormError>
          <hr />
        </div>
        <div>
          <SplitButton
            children="SplitButton"
            onClick={() => {}}
            customColor={Color.PRIMARY}
            buttonLoading={false}
            options={
              <div>
                <MenuItem onClick={() => {}}>Item 1</MenuItem>
                <MenuItem onClick={() => {}}>Item 2</MenuItem>
                <MenuItem onClick={() => {}}>Item 3</MenuItem>
              </div>
            }
          />
          <hr />
        </div>
        <div>
          <div>
            <LabelForm className={classes.formLabel}>Switch</LabelForm>
          </div>
          <Switch
            label="Switch start"
            labelPlacement="start"
            checked={isChecked}
            onChange={(_event: React.ChangeEvent<{}>, checked: boolean) => {
              setIsChecked(checked);
            }}
          />
          <Switch
            label="Switch bottom"
            labelPlacement="bottom"
            checked={isChecked}
            onChange={(_event: React.ChangeEvent<{}>, checked: boolean) => {
              setIsChecked(checked);
            }}
          />
          <Switch
            label="Switch end"
            labelPlacement="end"
            checked={isChecked}
            onChange={(_event: React.ChangeEvent<{}>, checked: boolean) => {
              setIsChecked(checked);
            }}
          />
          <Switch
            label="Switch top"
            labelPlacement="top"
            checked={isChecked}
            onChange={(_event: React.ChangeEvent<{}>, checked: boolean) => {
              setIsChecked(checked);
            }}
          />
          <hr />
        </div>
        <div>
          <div>
            <LabelForm className={classes.formLabel}>TableOutlineFilterButton</LabelForm>
          </div>
          <TableOutlineFilterButton
            onClickHandler={() => {}}
            label="TableOutlineFilterButton"
            tooltip="tooltip"
            countNumber={filterCount}
          />
          <hr />
        </div>
        <div>
          <div>
            <LabelForm className={classes.formLabel}>ToolTipInfo</LabelForm>
          </div>
          <ToolTipInfo title="ToolTipInfo" placement={TooltipPlacements.TOP}>
            <Button variant="contained" color="primary">
              ToolTipInfo Button
            </Button>
          </ToolTipInfo>
          <hr />
        </div>
        <div>
          <VoyagesSection />
        </div>
        <div>
          <DispatchSection />
        </div>
      </div>
    </div>
  );
}

export default function ExampleComponent() {
  return <Component />;
}
